package team.platforma.materialextension.sample_screens

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import team.platforma.materialextension.telegramOneTap.startOAuth
import team.platforma.materialextension.telegramOneTap.triggerOAuth

@Composable
fun OneTapScreen() {
    Box(
        modifier = Modifier.fillMaxSize()
    ) {
        startOAuth()
        Button(
            onClick = {
                //Sign in through telegram
                      triggerOAuth()
            },
            enabled = true,
            modifier = Modifier.fillMaxWidth(),
            colors = ButtonDefaults.buttonColors().copy(
                contentColor = Color.White,
                containerColor = Color.Blue
            )
        ) {
            Text(
                text = "Войти через Telegram", color = Color.White
            )
        }
    }
}